import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { FaSearchLocation } from 'react-icons/fa';
import { RxCross2 } from 'react-icons/rx';

const Searcher = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [query, setQuery] = useState(searchParams.get('search') || '');
  const [hasSearched, setHasSearched] = useState(searchParams.get('search'));

  const handleSearch = () => {
    if (!query.trim()) return; 
    setSearchParams({
      filter: searchParams.get('filter') || 'all',
      sort: searchParams.get('sort') || 'createdAt-desc',
      search: query,
      page: 1,
    });
    setHasSearched(true);
  };

  const handleReset = () => {
    const params = new URLSearchParams();
    params.set('filter', 'all');
    params.set('sort', 'name-asc');
    params.set('page', '1');
    setSearchParams(params);
    setQuery('');
    setHasSearched(false);
  };

  return (
    <div className="search-bar">
      <input
        type="text"
        className="search-bar-input"
        placeholder="Buscar por nombre del proyecto"
        value={query}
        onChange={e => setQuery(e.target.value)}
        onKeyDown={e => e.key === 'Enter' && handleSearch()}
      />
      <button
        className="search-bar__button"
        onClick={hasSearched ? handleReset : handleSearch}
      >
        {hasSearched ? (
          <RxCross2 className="search-bar__icon" />
        ) : (
          <FaSearchLocation className="search-bar__icon" />
        )}
      </button>
    </div>
  );
};

export default Searcher;
